module.exports = __webpack_public_path__ + "img/4-7456.5e9c0218.png";